const REGION_ALIASES: Record<string, string> = {
  '서울': '서울특별시', '서울시': '서울특별시',
  '부산': '부산광역시', '부산시': '부산광역시',
  '대구': '대구광역시', '대구시': '대구광역시',
  '인천': '인천광역시', '인천시': '인천광역시',
  '광주': '광주광역시', '광주시': '광주광역시',
  '대전': '대전광역시', '대전시': '대전광역시',
  '울산': '울산광역시', '울산시': '울산광역시',
  '세종': '세종특별자치시', '세종시': '세종특별자치시',
  '경기': '경기도',
  '강원': '강원특별자치도', '강원도': '강원특별자치도',
  '충북': '충청북도', '충남': '충청남도',
  '전북': '전북특별자치도', '전라북도': '전북특별자치도',
  '전남': '전라남도',
  '경북': '경상북도', '경남': '경상남도',
  '제주': '제주특별자치도', '제주도': '제주특별자치도'
};

const CANONICAL_REGIONS = Array.from(new Set(Object.values(REGION_ALIASES)));

/** 공개된 주소에서 등기 유형 접두어와 시·도 명칭 차이를 보정한다. */
export function getCanonicalHouseRegion(address: unknown): string {
  const value = String(address ?? '').trim();
  if (!value) {
    return '기타';
  }

  const tokens = getHouseAddressTokens(value);

  // 통합 행정구역명은 두 번째 토큰으로 기존 광주광역시와 전라남도를 구분한다.
  if (tokens[0] === '전남광주통합특별시') {
    return tokens[1]?.endsWith('구') ? '광주광역시' : '전라남도';
  }

  const canonicalRegion = CANONICAL_REGIONS.find(region => value.includes(region));
  if (canonicalRegion) {
    return canonicalRegion;
  }

  const alias = tokens.find(token => REGION_ALIASES[token]);

  return alias ? REGION_ALIASES[alias] : '기타';
}

/** 등기 유형 접두어를 제외한 주소 토큰을 반환한다. */
export function getHouseAddressTokens(address: unknown): string[] {
  return String(address ?? '')
    .trim()
    .replace(/^(?:(?:\([^)]*\)|\[[^\]]*])\s*)+/, '')
    .split(/\s+/)
    .filter(Boolean);
}
